/* Search by image: the camera button in the header search opens a picker, the chosen photo is
   compared with the catalog images (colour histogram + coarse layout) and the closest matches
   are shown in a panel. Runs fully in the browser; nothing is uploaded. */
(function () {
  /* The catalog is rendered by the header section (#ImageSearchCatalog) from the collection chosen in
     Theme settings > Header > Search-by-image catalog. */
  var CATALOG = [];
  function readCatalog() {
    if (CATALOG.length) return;
    var el = document.getElementById('ImageSearchCatalog');
    if (!el) return;
    try {
      CATALOG = JSON.parse(el.textContent || '[]').map(function (p) { return { name: p.name, src: p.image, url: p.url, price: p.price, sig: null }; });
    } catch (e) { CATALOG = []; }
  }

  var CSS = '.imgs-ov{position:fixed;inset:0;z-index:2000;background:rgba(22,24,27,.55);display:flex;align-items:flex-start;justify-content:center;padding:40px 16px;overflow:auto;font-family:"Instrument Sans",sans-serif}' +
    '.imgs-ov[hidden]{display:none}' +
    '.imgs-box{background:#fff;color:#16181B;border-radius:20px;width:100%;max-width:760px;padding:24px;box-shadow:0 20px 60px rgba(0,0,0,.3)}' +
    '.imgs-head{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:16px}' +
    '.imgs-title{margin:0;font-family:"Bricolage Grotesque",sans-serif;font-size:22px;font-weight:700}' +
    '.imgs-x{border:none;background:#F1EADF;width:36px;height:36px;border-radius:50%;font-size:20px;line-height:1;cursor:pointer;color:#16181B}' +
    '.imgs-drop{border:2px dashed #D8CDBE;border-radius:16px;padding:32px 16px;text-align:center;background:#FBF8F3}' +
    '.imgs-drop.is-over{border-color:#0D5C4E;background:#EAF3F0}.imgs-drop p{margin:0 0 14px;color:#4A4740}' +
    '.imgs-btn{border:none;background:#16181B;color:#fff;font-weight:700;font-size:15px;height:44px;padding:0 22px;border-radius:12px;cursor:pointer}' +
    '.imgs-btn--ghost{background:#fff;color:#16181B;border:1.5px solid #16181B}' +
    '.imgs-row{display:flex;gap:16px;align-items:center;margin-bottom:18px}.imgs-prev{width:96px;height:96px;object-fit:cover;border-radius:12px;border:1px solid #D8CDBE;flex:0 0 auto}' +
    '.imgs-sub{font-size:14px;color:#4A4740;margin:0 0 10px}' +
    '.imgs-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px}' +
    '.imgs-card{display:flex;flex-direction:column;gap:6px;text-decoration:none;color:#16181B;border:1px solid #E8E0D3;border-radius:14px;padding:8px}' +
    '.imgs-card:hover{border-color:#16181B}.imgs-card img{width:100%;aspect-ratio:1;object-fit:cover;border-radius:10px}' +
    '.imgs-card span{font-size:14px;font-weight:600}.imgs-card small{font-size:12px;color:#0D5C4E;font-weight:600}' +
    '.imgs-msg{color:#8A2E12;font-weight:600;font-size:14px;margin:0 0 12px}' +
    '@media(max-width:575.98px){.imgs-ov{padding:0;align-items:flex-end}.imgs-box{border-radius:20px 20px 0 0;max-height:92vh;overflow:auto;padding:18px}.imgs-grid{grid-template-columns:repeat(2,1fr)}}';

  var ov, input;

  function load(src) {
    return new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = rej; im.src = src;
    });
  }

  // 4x4x4 colour histogram plus a 3x3 grid of mean colours, from a 32px downsample
  function signature(im) {
    var s = 32, c = document.createElement('canvas'); c.width = c.height = s;
    var x = c.getContext('2d'); x.drawImage(im, 0, 0, s, s);
    var d = x.getImageData(0, 0, s, s).data, hist = new Array(64).fill(0), grid = new Array(27).fill(0), cnt = new Array(9).fill(0);
    for (var i = 0; i < d.length; i += 4) {
      var r = d[i], g = d[i + 1], b = d[i + 2], p = i / 4;
      var gx = Math.floor((p % s) / (s / 3)), gy = Math.floor(Math.floor(p / s) / (s / 3)), cell = gy * 3 + gx;
      hist[(r >> 6) * 16 + (g >> 6) * 4 + (b >> 6)]++;
      grid[cell * 3] += r; grid[cell * 3 + 1] += g; grid[cell * 3 + 2] += b; cnt[cell]++;
    }
    var n = s * s; hist = hist.map(function (v) { return v / n; });
    for (var k = 0; k < 27; k++) grid[k] = grid[k] / cnt[Math.floor(k / 3)] / 255;
    return { hist: hist, grid: grid };
  }

  function similarity(a, b) {
    var inter = 0, i, dist = 0;
    for (i = 0; i < 64; i++) inter += Math.min(a.hist[i], b.hist[i]);
    for (i = 0; i < 27; i++) dist += Math.abs(a.grid[i] - b.grid[i]);
    return 0.65 * inter + 0.35 * (1 - dist / 27);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function ensureCatalog() {
    readCatalog();
    return Promise.all(CATALOG.map(function (p) {
      if (p.sig) return p;
      return load(p.src).then(function (im) { p.sig = signature(im); }, function () { p.sig = null; });
    }));
  }

  function body() { return ov.querySelector('.imgs-body'); }

  function build() {
    if (ov) return;
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    ov = document.createElement('div'); ov.className = 'imgs-ov'; ov.hidden = true;
    ov.setAttribute('role', 'dialog'); ov.setAttribute('aria-modal', 'true'); ov.setAttribute('aria-label', 'Search by image');
    ov.innerHTML = '<div class="imgs-box"><div class="imgs-head"><h2 class="imgs-title">Search by image</h2><button type="button" class="imgs-x" aria-label="Close">&times;</button></div><div class="imgs-body"></div></div>';
    document.body.appendChild(ov);
    input = document.createElement('input'); input.type = 'file'; input.accept = 'image/*'; input.hidden = true; document.body.appendChild(input);
    input.addEventListener('change', function () { if (input.files && input.files[0]) handle(input.files[0]); input.value = ''; });
    ov.addEventListener('click', function (e) { if (e.target === ov || e.target.closest('.imgs-x')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
  }

  function showPicker(msg) {
    body().innerHTML = (msg ? '<p class="imgs-msg">' + msg + '</p>' : '') +
      '<div class="imgs-drop"><p>Drop a photo here, or take one with your camera, to find similar products.</p><button type="button" class="imgs-btn imgs-pick">Choose a photo</button></div>';
    var drop = body().querySelector('.imgs-drop');
    body().querySelector('.imgs-pick').onclick = function () { input.click(); };
    ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) handle(f); });
  }

  function handle(file) {
    if (!/^image\//.test(file.type)) { showPicker('Please choose an image file (JPG, PNG, WebP).'); return; }
    var url = URL.createObjectURL(file);
    body().innerHTML = '<div class="imgs-row"><img class="imgs-prev" src="' + url + '" alt="Your photo"><p class="imgs-sub">Finding similar products…</p></div>';
    Promise.all([load(url), ensureCatalog()]).then(function (r) {
      var q = signature(r[0]);
      var ranked = CATALOG.filter(function (p) { return p.sig; }).map(function (p) { return { p: p, s: similarity(q, p.sig) }; })
        .sort(function (a, b) { return b.s - a.s; }).slice(0, 8);
      if (!ranked.length) throw new Error('empty');
      body().innerHTML = '<div class="imgs-row"><img class="imgs-prev" src="' + url + '" alt="Your photo"><div><p class="imgs-sub">Closest matches for your photo</p><button type="button" class="imgs-btn imgs-btn--ghost imgs-again">Try another photo</button></div></div><div class="imgs-grid">' +
        ranked.map(function (m) {
          return '<a class="imgs-card" href="' + esc(m.p.url) + '"><img src="' + esc(m.p.src) + '" alt=""><span>' + esc(m.p.name) + '</span><small>' + esc(m.p.price) + ' · ' + Math.round(m.s * 100) + '% match</small></a>';
        }).join('') + '</div>';
      body().querySelector('.imgs-again').onclick = function () { input.click(); };
    }).catch(function () { showPicker('Sorry, we could not read that image. Try a different photo.'); });
  }

  function open() { build(); showPicker(); ov.hidden = false; document.body.style.overflow = 'hidden'; input.click(); }
  function close() { ov.hidden = true; document.body.style.overflow = ''; }

  // the header is re-rendered by the page runtime, so listen on the document
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.site-search__camera')) { e.preventDefault(); open(); }
  });
})();
